var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16669 3.50002C1.16669 3.17786 1.42786 2.91669 1.75002 2.91669H12.25C12.5722 2.91669 12.8334 3.17786 12.8334 3.50002C12.8334 3.82218 12.5722 4.08335 12.25 4.08335H1.75002C1.42786 4.08335 1.16669 3.82218 1.16669 3.50002Z",
    fill: "#8D8E92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16669 7.01879C1.16669 6.69661 1.42786 6.43546 1.75002 6.43546H12.25C12.5722 6.43546 12.8334 6.69661 12.8334 7.01879C12.8334 7.34096 12.5722 7.60212 12.25 7.60212H1.75002C1.42786 7.60212 1.16669 7.34096 1.16669 7.01879Z",
    fill: "#8D8E92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75002 9.95428C1.42786 9.95428 1.16669 10.2154 1.16669 10.5376C1.16669 10.8597 1.42786 11.121 1.75002 11.121H12.25C12.5722 11.121 12.8334 10.8597 12.8334 10.5376C12.8334 10.2154 12.5722 9.95428 12.25 9.95428H1.75002Z",
    fill: "#8D8E92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuicon);
export default __webpack_public_path__ + "static/media/menuicon.47a5305f9fc44cea27e3d6c91b940041.svg";
export { ForwardRef as ReactComponent };